import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import * as actions from './actions'
import denormalize from 'json-api-denormalizer'
import { readEndpoint } from 'redux-json-api'
import StudentDashboard from '../../components/StudentDashboard'

class FamilyDashboardContainer extends React.Component {
  componentDidMount() {
    this.conditionalFetchData()
  }

  conditionalFetchData = ()=> {
    const { dispatch, collection, isReading, isInitializing } = this.props
    const shouldFetch = !isReading && isInitializing

    if(shouldFetch){
      dispatch(readEndpoint('/quests?include=module'))
      dispatch(readEndpoint('/assignments?include=quest'))
      dispatch(readEndpoint('/quest-attempts?include=quest'))
      dispatch(readEndpoint('/profiles?filter[relation]=me?include=child-profiles'))
      dispatch(actions.initializeFamilyDashboard())
    }
  }

  render() {
    return(
      <StudentDashboard {...this.props}/>
    )
  }
}

const mapStateToProps = state => {
  const { profileId, crudAction } = state.familyRouting
  const { isInitializing } = state.familyDashboard
  const { isReading } = state.api
  const denormalizedApi = denormalize(state.api)

  const profiles = denormalizedApi.profiles
  const currentProfile = _.find(profiles, (profile,uuid)=>uuid === profileId)

  return {
    profileId,
    crudAction,
    isInitializing,
    isReading,
    currentProfile,
    profiles: denormalizedApi.profiles || {},
    quests: denormalizedApi.quests || {},
    assignments: denormalizedApi.assignments || {},
    questAttempts: denormalizedApi['quest-attempts'] || {}
  }
}

export default connect(mapStateToProps)(FamilyDashboardContainer)
